import React, { useCallback } from "react";
import { useMappedState } from "redux-react-hook";
import { Route, Switch } from "react-router-dom";
import { Bullseye } from "@patternfly/react-core";
import Layout from "../components/general/Layout";
import PageNotFound from "../components/general/PageNotFound";
import UserListContainer from "./UserListContainer";
import CreateUserContainer from "./CreateUserContainer";
import { isAdmin, isProductManager } from "../utils/userUtil";

export default () => {
  const mapState = useCallback(
    (state) => ({
      currentUser: state.userState.currentUser,
    }),
    []
  );
  const { currentUser } = useMappedState(mapState);

  return (
    <Layout>
      {isAdmin(currentUser.roles) || isProductManager(currentUser.roles) ? (
        <Switch>
          <Route path="/user/list" component={UserListContainer} />
          <Route path="/user/create" component={CreateUserContainer} />
          <Route path="/user/:userId/edit" component={CreateUserContainer} />
        </Switch>
      ) : (
        <Bullseye>
          <PageNotFound />
        </Bullseye>
      )}
    </Layout>
  );
};
